/* 
 * Export component file to be used on project
*/

import ProfessionalCard from './ProfessionalCard';
export default ProfessionalCard;
